<template>
  <div class="accordion-pager">
    <div class="button__next" v-if="currentStep < stepsList.length - 1" >
      <btn :type="btnType || 'primary'" class="w-100" :class="'step'+currentStep" :disabled="next" v-on:click="toggleAccordion(currentStep + 1)">
        <slot>{{ isVirtualCard && currentStep === stepType.START && pageType !== 'form' ? 'Przejdź do zamówienia' : 'Kontynuuj' }}</slot>
      </btn>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { checkProductsIsVirtualCard } from '@/utils/categoryUtils';

export default {
  name: 'AccordionPager',
  props: ['pageType', 'btnType'],
  methods: {
    toggleAccordion(index) {
      this.$emit('next', index);
    },
    stepBack(index) {
      let idx = index;
      if ((!this.isGuest && idx === this.stepType.LOGIN) || idx === this.stepType.ADDITIONAL_INFO) {
        idx -= 1;
      }
      this.$store.dispatch('steps/setCurrentStep', idx);
    },
  },
  data() {
    return {
      next: false,
    };
  },
  computed: {
    ...mapState({
      stepsList: state => state.steps.stepsList,
      currentStep: state => state.steps.currentStep,
      stepType: state => state.steps.stepType,
      isGuest: state => state.cart.userIsGuest,
    }),
    ...mapGetters([
      'getProductLoaded',
      'allProducts',
      'getProductType',
    ]),
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
    display(type) {
      return type === 'next';
    },
  },
};
</script>

<style scoped>

</style>
